import { apiCall } from './gqlClient';

const GOOGLEMEETCHECKIFPROVIDERCONNECTED_QUERY = `
  query googleMeetCheckIfProviderConnected {
    googleMeetCheckIfProviderConnected
  }`;

export const googleMeetCheckIfProviderConnectedApiCall = async () => apiCall({ query: GOOGLEMEETCHECKIFPROVIDERCONNECTED_QUERY, variables: {}});

const DISCONNECTGOOGLEMEET_QUERY = `
  mutation disconnectGoogleMeet {
    disconnectGoogleMeet
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const disconnectGoogleMeetApiCall = async (fragments = null) => apiCall({ query: DISCONNECTGOOGLEMEET_QUERY, variables: {}, fragments });

const CANCELGOOGLEMEET_QUERY = `
  mutation cancelGoogleMeet($eventId: String!, $pId: Int) {
    cancelGoogleMeet(eventId: $eventId, pId: $pId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const cancelGoogleMeetApiCall = async ({eventId, pId}, fragments = null) => apiCall({ query: CANCELGOOGLEMEET_QUERY, variables: {eventId, pId}, fragments });

const CREATEGOOGLEMEET_QUERY = `
  mutation createGoogleMeet($start: JSON!, $end: JSON!, $description: String!, $isUtc: Boolean) {
    createGoogleMeet(start: $start, end: $end, description: $description, isUtc: $isUtc)
    {
      id
			uri
      ...fragments
    }
  }`;

export const createGoogleMeetApiCall = async ({start, end, description, isUtc}, fragments = null) => apiCall({ query: CREATEGOOGLEMEET_QUERY, variables: {start, end, description, isUtc}, fragments });

const UPDATEGOOGLEMEET_QUERY = `
  mutation updateGoogleMeet($start: JSON!, $end: JSON!, $eventId: String!, $isUtc: Boolean) {
    updateGoogleMeet(start: $start, end: $end, eventId: $eventId, isUtc: $isUtc)
    {
      id
			uri
      ...fragments
    }
  }`;

export const updateGoogleMeetApiCall = async ({start, end, eventId, isUtc}, fragments = null) => apiCall({ query: UPDATEGOOGLEMEET_QUERY, variables: {start, end, eventId, isUtc}, fragments });
